import React, { useEffect, useState } from "react";
import Button from "./Button";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
} from "../../redux/Reducer/Admin/PartnerSlice";

const UserTabs = ({ tabs, showContent }) => {
  const [activeTab, setActivTab] = useState(0);

  const dispatch = useDispatch();

  const { activatedTab } = useSelector(
    ({ formSwitcher }) => ({
      activatedTab: formSwitcher?.changeTab,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (activatedTab?.index !== undefined) {
      setActivTab(activatedTab.index);
      dispatch(setActiveTab({ name: "", index: "" }));
    }
  }, [activatedTab, dispatch]);
  // useEffect(() => {
  //   const handleTabChange = () => {
  //     setActivTab(0);
  //   };
  //   window.addEventListener("tabChangeEventStore", handleTabChange);
  //   return () => {
  //     // dispatch(setChangeTab({ name: "", index: "" }));
  //     window.removeEventListener("tabChangeEventStore", handleTabChange);
  //   };
  // }, [activatedTab]);

  return (
    <div className="w-full">
      <ul className="flex items-center gap-[10px] mb-4">
        {tabs?.map((tab, index) => (
          <li key={index} className="flex-1">
            <Button
              className={`text-[13px] capitalize rounded-[8px] w-full py-2 px-4 bg-primary-600 text-white h-[40px] ${
                activeTab === index
                  ? " text-[13px] capitalize rounded-[8px] w-full py-2 px-4 bg-primary-700 text-white h-[40px]"
                  : "border-transparent text-secondry-600"
              }`}
              onClick={() => setActivTab(index)}
            >
              {tab.name}
            </Button>
          </li>
        ))}
      </ul>

      {/* Tab content */}
      {showContent ? <div>{tabs[activeTab].content}</div> : null}
    </div>
  );
};

export default UserTabs;
